export class ContentFilter {
  constructor(options = {}) {
    const defaults = {
      tabSelector: '.c-content-filter__tab',
      contentSelector: '.c-content-filter__item',
      fadeInClass: 'is-fade-in',
      activeClass: 'is-active',
    };

    options = Object.assign({}, defaults, options);

    this.tabs = document.querySelectorAll(options.tabSelector);
    this.contents = document.querySelectorAll(options.contentSelector);
    this.fadeInClass = options.fadeInClass;
    this.activeClass = options.activeClass;

    this.init();
  }

  init() {
    this.tabs.forEach((button) => {
      button.addEventListener('click', () => this.filter(button));
    });

    this.contents.forEach((item) => {
      item.addEventListener('animationend', () => {
        item.classList.remove(this.fadeInClass);
      });
    });
  }

  filter(button) {
    // Remove active class from all tabs and add to the clicked one
    this.tabs.forEach((tab) => {
      tab.classList.remove(this.activeClass);
    });
    button.classList.add(this.activeClass);

    const selectedCategory = button.getAttribute('data-filter-cat');

    this.contents.forEach((item) => {
      const contentCategory = item.getAttribute('data-filter-cat');

      if (contentCategory === selectedCategory || selectedCategory === 'all') {
        item.style.display = 'block';
        item.classList.add(this.fadeInClass);
      } else {
        item.style.display = 'none';
      }
    });
  }
}
